import { 
	UpgradePagesTilesRoot,
	UpgradePagesTilesWrapper,
} from './UpgradePagesTiles.styled';
import { UpgradePagesTile } from './UpgradePagesTile';
import { Heading } from './HeroSectionVideo.styled';
import { FeatureText } from './HeroSectionVideo.styled';
import { IconPosition } from '../button/ButtonVariant';

interface Props {
	headerTitle?: string;
	headerTitleColored?: string;
	headerTitlePosition?: IconPosition;
	
	tiles: Array<{
		icon: string;
		tileTitle: string;
		tileDescription: string;
		isFullWidth?: boolean;
	}>;
}

export const UpgradePagesTiles = ({ 
	headerTitle,
	headerTitleColored,
	headerTitlePosition = 'left',
	tiles,
}: Props) => {
    
	return (
		<UpgradePagesTilesWrapper>
			{headerTitle && (
				<Heading>
					{headerTitlePosition === 'right' && <><FeatureText>{headerTitleColored}</FeatureText>&nbsp;</>}
					<span>{headerTitle}</span>
					{headerTitlePosition === 'left' && <>&nbsp;<FeatureText>{headerTitleColored}</FeatureText></>}
				</Heading>
			)}
			{ tiles && tiles.length > 0 && (
				<UpgradePagesTilesRoot>
					{tiles.map((tile) => (
						<UpgradePagesTile
							key={tile.icon}
							icon={tile.icon}
							tileTitle={tile.tileTitle}
							tileDescription={tile.tileDescription}
							isFullWidth={tile.isFullWidth}
							
						/>
					))}
				</UpgradePagesTilesRoot>
			)}
		</UpgradePagesTilesWrapper>
	);
};
